<template>
<div class="bg-light">    
  <Banner
    title="Construction"
    pricing="true"
    level="1"
    bg-color="#fff"
    class="sticky-top"
    />
  
  
  
  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <b-container
    class="py-3 p-lg-5 text-center"
    style="background-color: #d5d5d5;"
    fluid
    >
    <b-row>
      <b-col cols="12">
	<b-container
	  class="bg-white rounded p-4 p-lg-5"
	  fluid
	  >
	  <b-row>
	    <b-col
	      cols="12"
	      lg="3"
	      class="my-auto"
	      >
	      <b-img
		:src="require('../assets/trinapp_crosslink.png')"
		style="height: 160px;"
		/>
	    </b-col>
	    <b-col
	      cols="12"
	      lg="6"
	      >
	      <div class="my-auto">
		<h1>TrinApp<sup>&trade;</sup> Crosslink</h1>
	      </div>
	      <p>Automatically create clickable page links between all your PDF Drawings and Specs
		<br>
		<span class="font-weight-bold">soon with Oracle aconex Link</span>
		<br>Extraction & publishing into Oracle aconex of Sheet Number, Sheet Title and Discipline.</p>
	    </b-col>
	    <b-col
	      cols="12"
	      lg="3"
	      class="mt-auto"
	      >
	      <div class="mb-2">
		<b-button
		  class="btn-outline-yellow mx-auto"
		  style="width: 200px;"
		  to="/construction/trinpod/aconex">
		  aconex Link
		</b-button>
	      </div>
	      <div>
		<b-button
		  class="btn-yellow mx-auto"
		  style="width: 200px;"
		  to="/construction/trinapps/trinapp/cde/crosslink">
		  Crosslink
		</b-button>
	      </div>
	    </b-col>
	  </b-row>
	</b-container>
      </b-col>
    </b-row>
    <b-row>
      <b-col
	cols="12"
	xl="6"
	class="py-3"
	>
	<b-container
	  class="bg-white rounded p-4 p-lg-5 h-100"
	  fluid
	  >
	  <b-row>
	    <b-col
	      cols="12"
	      xl="5"
	      class="order-1"
	      >
	      <b-img
		:src="require('../assets/trinpod_secure.png')"
		style="height: 160px;"
		/>
	    </b-col>
	    <b-col
	      cols="12"
	      xl="7"
	      class="py-3 order-3 order-xl-2"
	      >
	      <p>Industrial strength Solid Pod capable of handling a massive amount of data, stored in a graph DB with conceptual computing through Trinity AI.</p>
	    </b-col>
	    <b-col
	      cols="12"
	      xl="5"
	      class="my-auto order-2 order-xl-3"
	      >
	      <h1>TrinPod<sup>&trade;</sup></h1>
	    </b-col>
	    <b-col
	      cols="12"
	      xl="7"
	      class="py-3 order-4"
	      >
	      <b-button
		class="btn-yellow"
		to="/construction/trinpod"
		>
		TrinPod<sup>&trade;</sup>
	      </b-button>
	    </b-col>
	  </b-row>
	</b-container>	
      </b-col>
      <b-col
	cols="12"
	xl="6"
	class="py-3"
	>
	<b-container
	  class="bg-white rounded p-4 p-lg-5 h-100"
	  fluid
	  >
	  <b-row>
	    <b-col
	      cols="12"
	      xl="7"
	      class="order-1"
	      >
	      <b-img
		:src="require('../assets/trinapp_cde.png')"
		style="height: 160px;"
		/>
	    </b-col>
	    <b-col
	      cols="12"
	      xl="5"
	      class="py-3 order-3 order-xl-2"
	      >
	      <p>File storage built on top of TrinPods with Trinity conceptual AI.</p>
	    </b-col>
	    <b-col
	      cols="12"
	      xl="7"
	      class="my-auto order-2 order-xl-3"
	      >
	      <h1>TrinApp<sup>&trade;</sup> CDE</h1>
	    </b-col>
	    <b-col
	      cols="12"
	      xl="5"
	      class="py-3 order-4"
	      >
	      <b-button
		class="btn-yellow"
		to="/construction/trinapps/trinapp/cde"
		>
		CDE
	      </b-button>
	    </b-col>
	  </b-row>
	</b-container>	
      </b-col>
    </b-row>
  </b-container>



  <b-container style="background-color: #ffb300; font-family: Arial, Helvetica, sans-serif; font-size: 1.2rem;" fluid>
    <b-row class="text-center">
      <b-col cols="4" sm="3" lg="1" offset-lg="2">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('trinapps')"
	  >
	  <span class="link-ref-text">TrinApps</span>
	</b-button>
      </b-col>
      <b-col cols="4" sm="3" lg="1">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('trinpod')"
	  >
	  <span class="link-ref-text">TrinPod<sup>&trade;</sup></span>
	</b-button>
      </b-col>
      <b-col cols="4" sm="3" lg="1">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('trinapp')"
	  >	  
	  <span class="link-ref-text">LaunchPad</span>
	</b-button>
      </b-col>
      <b-col cols="4" sm="2" lg="1">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('cde')"
	  >	  
	  <span class="link-ref-text">CDE</span>
	</b-button>
      </b-col>
      <b-col cols="4" sm="3" lg="1">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('crosslink')"
	  >	  
	  <span class="link-ref-text">Crosslink</span>
	</b-button>
      </b-col>
      <b-col cols="4" sm="3" lg="1">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('aconex')"
	  >	  
	  <span class="link-ref-text">aconex</span>
	</b-button>
      </b-col>
      <b-col cols="4" sm="3" lg="1">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('news')"
	  >	  
	  <span class="link-ref-text">News</span>
	</b-button>
      </b-col>
      <b-col cols="4" sm="3" lg="1">
	<b-button
	  class="border-0 bg-transparent text-dark px-lg-2"
	  style="height: 64px;"
	  @click="goto('approach')"
	  >	  
	  <span class="link-ref-text">Approach</span>
	</b-button>
      </b-col>
    </b-row>
  </b-container>



	<VideoSection 
		title="vimeo-crosslink-demo" 
		src="https://player.vimeo.com/video/559730100"
	/>
  
  

  <div ref="trinapps" />
  <TrinAppsFamily />

  

  <div ref="trinpod" />
  <div style="background-color: #ffb300; height: 16px;" />
  
  

  <Layout11>
    <div slot="icon">
      <b-img
	:src="require('../assets/trinpod_secure.png')"
	class="pt-5"
	style="width: 200px;"
	/>
    </div>
  </Layout11>
  
  

  <div ref="trinapp" />
  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <Layout12 />
  
  

  <div ref="cde" />
  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <Layout01>
    <div slot="icon">
      <b-img :src="require('../assets/trinapp_cde.png')" class="mr-3" style="height: 114px;" />
    </div>
    <div slot="header">
      TrinApp <span class="gmx-red">CDE</span>
    </div>
    <div slot="subtitle">
      File storage built on top of TrinPods with Trinity conceptual AI.
    </div>
    <div slot="description">
      As Construction professionals ourselves, we think you should have 100% ownership and control over your construction data, files, drawings and specs; who has access to your data, where it is stored, and what apps you use to access it.
    </div>
    <div slot="buttons">
      <b-button	
	size="lg"
	class="btn-orange mt-5 mx-3"
	style="width: 200px;"
	to="/construction/trinapps/trinapp/cde"
	@click.native="scrollToTop()"
	>
	CDE
      </b-button>
    </div>
  </Layout01>
  
  

  <div ref="crosslink" />
  <div style="background-color: #ffb300; height: 16px;" />
  
  
  
  <Layout09>
    <div slot="button">
      <b-button
	size="lg"
	class="btn-yellow mt-5 mx-3"
	
	to="/construction/trinapps/trinapp/cde/crosslink"
	@click.native="scrollToTop()"
	>
	Crosslink
      </b-button>
      <b-button
	size="lg"
	class="btn-orange mt-5 mx-3"
	href="https://trinpod.us/pricing?industry=construction"
	>
	Get Started
      </b-button>
    </div>
  </Layout09>
  
  

  <div ref="aconex" />
  <div style="background-color: #ffb300; height: 16px;" />



  <Layout10>
    <div slot="buttons">
      <b-button
	size="lg"
	class="btn-yellow mt-5 mx-3"
	to="/construction/trinpod/aconex"
	@click="scrollToTop()"
	>
	aconex Link
      </b-button>
      <b-button
	size="lg"
	class="btn-orange mt-5 mx-3"
	href="https://trinpod.us/pricing?industry=construction"
	>
	Get Started
      </b-button>
    </div>
  </Layout10>

  

  <div ref="news" />
  <div style="background-color: #ffb300; height: 16px;" />



  <InterestedInNews />



  <div ref="approach" />
  <div style="background-color: #ffb300; height: 16px;" />


  <b-container
    class="py-5 d-flex section"
    fluid
    >
    <b-row class="justify-content-center align-self-center mx-auto">
      <b-col>
	<b-container>
	  <b-row>
	    <b-col>
	      <div class="py-5 text-center">
		<h1>Welcome to <span class="neon-blue">Graph</span><span class="gmx-red">metrix</span></h1>
	      </div>
	      <div class="px-md-5">
		<h2 class="mb-5">Companies in the Construction industry are finding themselves locked into software services costing them time rather than saving it. Construction companies have also lost control of one of their most valuable assets, their information.</h2>
		
		<h2 class="mb-5">This all changes with Graphmetrix.</h2>
		
		<h2 class="mb-5">We give information control and ownership back to construction companies and allow instant access to what is needed when it's needed with the TrinPod conceptually integrated One-World Model. Your TrinPods are in the cloud or on-premise, not with a big IT company, not locked up into siloed applications.</h2>
		
		<h2 class="mb-5">In addition to being compatible with the Solid and Linked data international standards, we are building a growing list of TrinPod Links to other systems starting with Oracle aconex, so that you can work with all your information in the One-World model.</h2>
	      </div>
	    </b-col>
	  </b-row>
	</b-container>
      </b-col>
    </b-row>
  </b-container>
  

  
  <div style="background-color: #ffb300; height: 16px;" />


  
  <b-container class="px-5 py-6" style="background-color: #08034c;" fluid>
    <b-row class="text-center text-light">
      <b-col>
	<h1>Start by
	  <br>Getting the TrinApp CDE with a TrinPod<sup>&trade;</sup></h1>
	<b-button size="lg"
		  class="btn-orange mb-5 mt-4 mx-3"
		  href="https://trinpod.us/pricing?industry=construction"
		  >
	  Get Started
	</b-button>
      </b-col>
    </b-row>
  </b-container>



  <div style="background-color: #ffb300; height: 16px;" />


  
  <GmxFooter /> 
</div>
</template>

<script>
import GmxFooter from '@/components/footer.vue';
import Banner from '@/components/gmx-banner.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import TrinAppsFamily from '@/components/trinapps-family.vue';
import VideoSection from '@/components/video-section.vue';
import Layout01 from '@/components/layout-01.vue';
import Layout09 from '@/components/layout-09.vue';
import Layout10 from '@/components/layout-10.vue';
import Layout11 from '@/components/layout-11.vue';
import Layout12 from '@/components/layout-12.vue';
import InterestedInNews from '@/components/interested-in-news.vue';
import * as log from 'loglevel'
export default {
    name: "Construction",
    components: {
	Banner,
	GmxFooter,
	FontAwesomeIcon,
	TrinAppsFamily,
	VideoSection,
	Layout01,
	Layout09,
	Layout10,
	Layout11,
	Layout12,
	InterestedInNews
    },
    data () {
	return {
            faCheck
        }
    },
    mounted () {
	window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy () {
	window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
	img: function (image) {
	    require(image)
	},
	onScroll: function () {
	    // Get the current scroll position
	    const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
	    if (currentScrollPosition < 0) {
		return
	    }
	    // Stop executing this function if the difference between
	    // current scroll position and last scroll position is less than some offset
	    if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
		return
	    }
	    this.showVerticalRight = currentScrollPosition < this.lastScrollPosition
	    this.showNavbarLogo = currentScrollPosition > this.lastScrollPosition
	    this.lastScrollPosition = currentScrollPosition
	},
	goto: function (refName) {
    	    var element = this.$refs[refName];
	    //log.debug(element);
	    var top = element.offsetTop;
      
	    window.scrollTo(0, top);
	},
	scrollToTop: function () {
	    window.scrollTo(0,0);
        }
    }
}
</script>

